export enum EmailMultiMailSourceType {
    UserInput = "UserInput",
    Client = "Client"
}